import { Component } from '@angular/core';
import { MessageBaseModel, MessageSource } from '@boxx/messages-core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-conversation-item-open',
  template: '',
  styleUrls: ['./conversation-item-open.component.scss'],
})
export class ConversationItemOpenComponent {
  get message(): MessageBaseModel {
    return this.myMessage;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  MESSAGE_SOURCE = MessageSource;

  protected myMessage: MessageBaseModel;

  constructor() {}
}
